import React from "react";
import classNames from "classnames";
import ReviewItemBContainer from "Containers/ReviewItemBContainer";
import ReviewItemBReplyContainer from "Containers/ReviewItemBReplyContainer";
import ReviewReplyFormContainer from "Containers/ReviewReplyFormContainer";
import withStyles from "react-jss";
import { CDN_URL_NO_PROTO } from "Constants/CDN";

const styles = (theme) => {
	return {
		root: {
			width: "100%",
			position: "relative",
			marginTop: "40px",
			paddingBottom: "1px",
			"&:after": {
				content: '""',
				position: "absolute",
				width: "6000px",
				height: "1px",
				backgroundColor: theme.palette.colors.lightGrayishViolet,
				bottom: 0,
				left: "-50%",
			},
			"&:first-child": {
				marginTop: 0,
			},
		},
		isSingle: {
			"&:after": {
				display: "none",
			},
		},
		list: {
			display: "flex",
			alignItems: "flex-start",
			marginBottom: "0",
			flexWrap: "wrap",
		},
		listWithButton: {
			marginBottom: 0,
		},
		moreWrapper: {
			maxHeight: 0,
			overflow: "hidden",
			transition: "max-height .5s ease",
			width: "100%",
		},
		more: {
			display: "flex",
			alignItems: "flex-start",
			flexWrap: "wrap",
		},
		button: {
			width: "780px",
			height: "60px",
			margin: "40px auto 40px",
			borderRadius: "10px",
			backgroundColor: theme.palette.colors.paleGrey,
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			cursor: "pointer",
			position: "relative",
			zIndex: "5",
		},
		buttonText: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1,
			letterSpacing: "2.3px",
			textAlign: "center",
			color: theme.palette.colors.purplishBlue,
			marginRight: "8px",
			textTransform: "uppercase",
		},
		buttonCounter: {
			fontFamily: theme.fonts.medium,
			fontSize: "12px",
			lineHeight: "0.83",
			color: theme.palette.colors.purplishBlue,
			marginTop: "-8px",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			button: {
				width: "620px",
				margin: "40px auto",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				marginTop: "40px",
			},
			list: {},
			button: {
				width: "100%",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				marginTop: "16px",
			},
			list: {
				marginBottom: "0",
			},
			button: {
				width: "280px",
				height: "auto",
				margin: "16px auto 16px",
				borderRadius: 0,
				border: "none",
				bottom: 0,
			},
			buttonText: {
				fontSize: "14px",
				lineHeight: "1.14",
				letterSpacing: "2px",
			},
		},
	};
};

class ReviewBranch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showButton: !!this.props.button,
		};
	}

	generateUserMessage(key, data) {
		let text = this.props.text;
		if (this.props.stub) {
			return (
				<ReviewItemBContainer
					stub={this.props.stub}
					key={key}
					textConst={text}
					item={data}
					markReviewAsViewed={() => {}}
					urlToProvider={"/"}
				/>
			);
		}

		return (
			<ReviewItemBContainer
				key={key}
				textConst={text}
				type={data.type}
				name={data.name && data.name.id ? data.name.name : text.UNKNOWN_GUEST}
				accepted={data.accepted}
				short={data.short}
				tags={data.tags}
				provider={data.provider}
				status={data.status}
				header={data.header}
				withFiles={data.withFiles}
				text={data.text}
				like={data.like}
				likes={data.likes}
				rating={data.rating}
				dislike={data.dislike}
				views_all={data.views_all}
				services_of_use={data.services_of_use}
				time_of_use={data.time_of_use}
				date={data.date}
				countCommetns={data.answers.count}
				specifications={data.specifications.list}
				item={data}
				markReviewAsViewed={(id) => this.props.markReviewAsViewed(id)}
				urlToProvider={this.props.urlToProvider}
				singleReview={this.props.singleReview}
			/>
		);
	}

	generateProviderMessage = (key, data) => {
		let text = this.props.text;
		return (
			<ReviewItemBReplyContainer
				key={key}
				name={data.user.name || ""}
				logo={data.user.photo}
				status={data.user.description}
				short={true}
				textConst={text}
				text={data.text}
				date={data.date}
				id={data.id}
			/>
		);
	};

	generateAdminMessage = (key, data) => {
		let text = this.props.text;
		return (
			<ReviewItemBReplyContainer
				key={key}
				name={(data.user && data.user.name) || ""}
				logo={(data.user && data.user.photo) || ""}
				status={(data.user && data.user.description) || ""}
				short={true}
				textConst={text}
				text={data.text}
				date={data.date}
				id={data.id}
			/>
		);
	};

	generateCommentMessage = (key, data) => {
		let text = this.props.text;
		if (this.props.stub) {
			return <ReviewItemBReplyContainer key={key} stub={this.props.stub} textConst={text} />;
		}
		const guestUrl = `${CDN_URL_NO_PROTO}/images/redesign/icons/Sunglasses.png`;
		return (
			<ReviewItemBReplyContainer
				key={key}
				name={!!data.user && data.user.name}
				logo={data.user ? data.user.photo : guestUrl}
				short={true}
				text={data.text}
				textConst={text}
				date={data.date}
				status={data.user?.description}
				id={data.id}
			/>
		);
	};

	generateMessage = (index, item) => {
		let comment;
		switch (item.type) {
			case "provider":
				comment = this.generateProviderMessage(index, item);
				break;
			case "admin":
				comment = this.generateAdminMessage(index, item);
				break;
			default:
				comment = this.generateCommentMessage(index, item);
				break;
		}
		return comment;
	};

	generateOtherMessages = () => {
		return this.props.data.answers.list.map((item, index) => {
			let comment;
			if (index == 0) return null;
			switch (item.type) {
				case "provider":
					comment = this.generateProviderMessage(index, item);
					break;
				case "admin":
					comment = this.generateAdminMessage(index, item);
					break;
				default:
					comment = this.generateCommentMessage(index, item);
					break;
			}

			return comment;
		});
	};

	openBranch = (e) => {
		this.setState({
			showButton: false,
		});
		this.moreWrapper.style.maxHeight = this.more.offsetHeight + "px";
	};

	render() {
		let review = this.props.data;
		let classes = this.props.classes;
		let text = this.props.text;
		return (
			<div
				className={classNames(classes.root, {
					[classes.isSingle]: this.props.withReply,
				})}
			>
				<div
					className={classNames(classes.list, {
						[classes.listWithButton]: this.state.showButton,
					})}
				>
					{this.generateUserMessage(0, review)}
					{this.props.data.answers.count > 0 &&
						this.props.data.answers.list.length > 0 &&
						this.generateMessage(1, this.props.data.answers.list[0])}

					{!this.props.withReply && (
						<div className={classes.moreWrapper} ref={(wrapper) => (this.moreWrapper = wrapper)}>
							<div className={classes.more} ref={(more) => (this.more = more)}>
								{this.generateOtherMessages()}
							</div>
						</div>
					)}
					{this.props.withReply && this.generateOtherMessages()}
				</div>
				{this.state.showButton && !this.props.withReply && (
					<div className={classes.button} onClick={this.openBranch}>
						<span className={classes.buttonText}>{text.SHOW_ALL_MESSAGES}</span>
						<span className={classes.buttonCounter}>{this.props.data.answers.count - 1}</span>
					</div>
				)}
				{this.props.withReply && (
					<ReviewReplyFormContainer
						reviewId={review.id}
						succesfullyReplyCallback={this.props.succesfullyReplyCallback}
					/>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(ReviewBranch);
